export function idToName(id: string): string {
  return id
    .split('_')
    .map((w: string) => w[0].toUpperCase() + w.slice(1))
    .join(' ');
}
